import { MenuEntry } from '@pancakeswap-libs/uikit'

const config: MenuEntry[] = [
  {
    label: 'CoineSwap',
    icon: 'HomeIcon',
    href: '/',
  }, 
  {
    label: 'Coine.io',
    icon: 'HomeIcon',
    href: 'https://coine.io',
  },
  {
    label: 'Trade',
    icon: 'TradeIcon',
    items: [
      {
        label: 'Exchange',
        href: 'https://exchange.pancakeswap.finance/#/swap?inputCurrency=0xe9e7cea3dedca5984780bafc599bd69add087d56&outputCurrency=0x4deC35b2cCcDBDbEF4910ab13724C2BaD8fA9f98',
      },
      {
        label: 'Liquidity',
        href: 'https://exchange.pancakeswap.finance/#/add/0xe9e7cea3dedca5984780bafc599bd69add087d56/0x4deC35b2cCcDBDbEF4910ab13724C2BaD8fA9f98',
      },
    ],
  },
  {
    label: 'Farms',
    icon: 'FarmIcon',
    href: '/farms',
  },
  {
    label: 'Stakes',
    icon: 'PoolIcon',
    href: '/nests',
  }, 
  {
    label: 'Countdown Farms',
    icon: 'InfoIcon',
    href: 'https://bscscan.com/block/countdown/9000000',
  },
  {
    label: 'CoineSwap',
    icon: 'InfoIcon',
    href: 'https://dxsale.app/app/v2_9/defipresale?saleID=18&chain=BSC',
  }, 
    {
    label: 'Masterchef',
    icon: 'AuditIcon',
    href: 'https://bscscan.com/address/0xeC4D912eF139789E30fFB2E0727E8cDd6483663A#code',
  },
  {
    label: 'CoineSwap Token',
    icon: 'AuditIcon',
    href: 'https://bscscan.com/address/0x4deC35b2cCcDBDbEF4910ab13724C2BaD8fA9f98#code',
  }, 
  {
    label: 'Timelock',
    icon: 'AuditIcon',
    href: 'https://bscscan.com/address/0x5467bB1bB865676a6703a49E464f7F4286874755#code',
  },
    {
    label: 'More',
    icon: 'MoreIcon',
    items: [
      {
        label: 'Github',
        href: 'https://github.com/CoineSwap',
      },
      {
        label: 'Docs',
        href: 'https://github.com/CoineSwap',
      },
    ],
  },
]

export default config
